import $ from 'jquery';
import checkMetamask from './utils/checkMetamask';
import login from './utils/checkLogin';
// import myWheel from './Spin2WinWheel';

const spinWheelAvxt = async () => {
  const spinWheelElementAvxt = $('.js-spin-wheel-nfsg');
  if (!spinWheelElementAvxt.length) {
    return;
  }

  let myWheel = null;

  const init = async () => {
    if (!await checkMetamask()) {
      return;
    }

    if (!await login()) {
      return;
    }

    const sessionKey = sessionStorage.getItem('sessionKey');
    spinWheelElementAvxt.off('click.spin');

    fetch(`/api/spin-wheel/join?sessionKey=${sessionKey}`)
      .then(response => response.json())
      .then((jsonData) => {
        if (myWheel) {
          Spin2WinWheel.reset();
        }
        // const mySpinBtn = document.querySelector('.spinBtn');
        myWheel = new Spin2WinWheel();
        // todo: @tekin
        myWheel.init({
          data: jsonData,
          // spinTrigger: mySpinBtn,
          onResult: () => {
            // myWheel.reset();
            // $('.spinBtn').off('click');
            spinWheelElementAvxt.on('click.spin', init);
          },
        });
        myWheel.trigger();
      });
  };

  spinWheelElementAvxt.on('click.spin', init);
};

export default spinWheelAvxt;
